import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import withStyles, {
  StyleRulesCallback,
  WithStyles
} from '@material-ui/core/styles/withStyles';
import { LayoutToolsProvider } from '../providers';

const styles: StyleRulesCallback = theme => ({
  wrapper: {
    backgroundColor: theme.palette.grey['200'],
    width: 340,
    padding: theme.spacing.unit * 2,
    overflowY: 'scroll'
  }
});

class SidePanel extends React.Component<WithStyles> {
  renderOpenPanel() {
    const { classes, children } = this.props;
    return (
      <Paper className={classes.wrapper} square={true} elevation={1}>
        {children}
      </Paper>
    );
  }

  render() {
    return (
      <LayoutToolsProvider>
        {layout => layout.state.panelOpen && this.renderOpenPanel()}
      </LayoutToolsProvider>
    );
  }
}

export default withStyles(styles)(SidePanel);



// WEBPACK FOOTER //
// ./src/containers/SidePanel.tsx